import { z } from 'zod';

export const coursesControllerCalculateGrade201Schema = z.number();

export const coursesControllerCalculateGrade400Schema = z.object({
  statusCode: z.enum(['400']),
  message: z.string(),
  type: z.enum(['InvalidData']),
  details: z.object({
    location: z.enum(['path', 'query', 'body']),
    explanation: z.object({
      issues: z.array(
        z
          .object({
            code: z.enum([
              'invalid_type',
              'invalid_literal',
              'custom',
              'invalid_union',
              'invalid_union_discriminator',
              'invalid_enum_value',
              'unrecognized_keys',
              'invalid_arguments',
              'invalid_return_type',
              'invalid_date',
              'invalid_string',
              'too_small',
              'too_big',
              'invalid_intersection_types',
              'not_multiple_of',
              'not_finite',
            ]),
            path: z.array(z.union([z.string(), z.number()])),
            message: z.string(),
          })
          .catchall(z.unknown()),
      ),
    }),
  }),
});

export const coursesControllerCalculateGrade404Schema = z.object({
  statusCode: z.enum(['404']),
  message: z.string(),
  type: z.enum(['ObjectNotFound']),
  details: z.enum(['null']).nullable(),
});

export const coursesControllerCalculateGradeMutationRequestSchema = z.object({
  courseId: z.string().uuid(),
  answers: z.array(
    z.object({ cardId: z.string().uuid(), optionIds: z.array(z.string()) }),
  ),
});

export const coursesControllerCalculateGradeMutationResponseSchema = z.number();
